<template>
    <v-container fill-height fluid>
                            
        <v-row align="center" justify="center">
            <!--<v-col class="display-2"><center>{{$store.state.config.HotelName}}</center></v-col>-->
            <v-col align="center" justify="center">

            <v-img :src="$store.state.config.LogoImageUrl" class="logocentr" contain/>
            </v-col>
            <v-col cols="12" class="display-1"><center>Benvenuto</center></v-col>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <v-col 
              v-if="!loading"
              cols="12" class="display-1"><center>{{Nominativo}}</center></v-col>


        </v-row>
        <v-row>
          <v-col align="center" justify="center"   v-if="$store.state.config.Precheckin=='1'">
            <div>
              <v-icon size="40" class="dot" v-ripple @click=" goto('home/'+$store.getters.reservationid)" >mdi-account-box</v-icon>
            </div>
            <div class="label_btn">
              Pre-checkin <v-icon v-if="checkin_done" color="green" >mdi-check</v-icon>
            </div>
          </v-col>
          <v-col align="center" justify="center" v-if="$store.state.config.Menu=='1'">
            <div>
              <div >
                <v-icon size="40" class="dot" v-ripple @click="goto('ristomenu')" >mdi-food</v-icon>
              </div>
              <div class="label_btn">
                Menu del Giorno
              </div>
            </div>

          </v-col>
          <v-col align="center" justify="center" v-if="$store.state.config.EstrattoConto=='1'">
            <div>
              <v-icon size="40" class="dot" v-ripple @click="goto('ec')">calculate</v-icon>
            </div>
            <div class="label_btn">
              Estratto Conto
            </div>
          </v-col>
          <v-col align="center" justify="center" v-if=" $store.state.config.Documenti=='1'">
            <div >
              <v-icon size="40" class="dot" v-ripple @click="goto('docs')">mdi-file-document</v-icon>
            </div>
            <div class="label_btn">
              Documenti
            </div>
          </v-col>
          <v-col align="center" justify="center" v-if=" $store.state.config.firmacontratto=='1'">
            <div >
              <v-icon size="40" class="dot" v-ripple @click="contrattofirmato?goto('docs'):goto('firma')">mdi-signature</v-icon>
            </div>
            <div class="label_btn">
              Contratto <v-icon v-if="contrattofirmato" color="green">mdi-check</v-icon>
            </div>
          </v-col>

          <v-col align="center" justify="center" v-if="$store.state.config.Pagamenti=='1'">

            <div>
              <v-icon size="40" class="dot" v-ripple @click="goto('pags')">mdi-currency-eur</v-icon>
            </div>
            <div class="label_btn">
              Pagamenti
            </div>
          </v-col>
          <v-col align="center" justify="center" >
            <div>
              <v-icon size="40" class="dot" v-ripple @click="goto('info')">info</v-icon>
            </div>
            <div class="label_btn">
              Info
            </div>
            </v-col>

        </v-row>
        


    </v-container>
</template>
<style>
.dot {
  height: 2em;
  width: 2em;
  background-color: rgba(248, 244, 244, 0.13);
  border-radius: 50%;
  display: inline-block;
  border-color: "primary";
  border-style: solid;
}
.label_btn {
  font-size: 1.1em;
  color: rgb(100, 100, 100);
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .logocentr {
  max-height:140px
}
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .logocentr {
  max-height:300px
}
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .logocentr {
  max-height:300px
}
}


</style>
<script>
export default {
    /* eslint-disable no-unused-vars */
        data:() => ({
            Nominativo:'',
            dal:'',
            al:'',
            loading:false
    }),
    mounted: function() {
      var itemId = this.$route.params.reservationid;
      if(!itemId){
        itemId = this.$store.getters.reservationid;
      }
      
      var apiurl = this.$store.state.settings.apiurl;
      console.log("carico prenotazione", itemId,apiurl);
      if(itemId){    
        this.setReservationid(apiurl, itemId);    
      }
      
    },
    computed:{
      checkin_done(){
        return this.$store.state.reservation.status=='CLOSED';
      },
      contrattofirmato(){
        console.log("verifico firma contratto",this.$store.state,this.$store.state.contrattofirmato,(this.$store.state.prenotazionehr && this.$store.state.prenotazionehr.ContrattoURL!="") )
        return this.$store.state.contrattofirmato || (this.$store.state.prenotazionehr && this.$store.state.prenotazionehr.ContrattoURL!="");
      }
    },
    methods:{
      goto(dest){
          this.$router.push({ path: `/`+dest })
      },
      verifica_step(){
            var a = this.$store.state.reservation 
            console.log("verifico steps",a);
            if(a && a.status=='CLOSED'){
              if(a && this.$store.state.config.firmacontratto == 1 && !this.$store.state.contrattofirmato){
                this.$router.push({ path: `/firma` })
              }else{
                this.$router.push({ path: `/` })
              }  
            }
            else{
              //se non ho compilato il precheckin vado alla pagina 
              this.$router.push({ path: `/privacy` })
            }
            return "verifica..."
      },
     setReservationid(apiurl, id) {
        this.idprenotazione = id
        this.loading= true;
        var thisp = this;
         this.$store.dispatch("setreservation", id).then(a=>{
            this.cambiacolori();        
            this.Nominativo = this.$store.state.reservation.ref
            if(this.$store.state.reservation && this.$store.state.reservation.mainguest){
                this.Nominativo = this.$store.state.reservation.mainguest.firstName
                 thisp.verifica_step();
            }
            this.loading= false;
         })

        console.log("setreservationid", id);
      },
    cambiacolori(){
        console.log("applica colore")
        this.$vuetify.theme.isDark = false
        this.$vuetify.theme.themes.light.primary = this.$store.state.config.ThemeColor
      },
    }

}
</script>
